import script from "./BundlePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./BundlePicker.vue?vue&type=script&setup=true&lang=ts"

import "./BundlePicker.vue?vue&type=style&index=0&id=6a913807&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a913807"]])

export default __exports__